import { format } from "date-fns";
import { getDateFnsLocale as getLocale } from "./language";

export const formatDate = (date: string | Date | undefined | null) => {
  if (!date) return "";
  // A date-only string is a calendar day, not an instant: new Date("YYYY-MM-DD")
  // parses it as UTC midnight, which browsers west of UTC render as the day
  // before. Pin it to local midnight instead.
  const d =
    typeof date === "string"
      ? new Date(/^\d{4}-\d{2}-\d{2}$/.test(date) ? `${date}T00:00:00` : date)
      : date;
  if (isNaN(d.getTime())) return "";
  return format(d, "dd MMM yyyy", { locale: getLocale() });
};

export const formatDateRange = (
  startDateString: string,
  endDateString: string,
): string => {
  const startDate = new Date(startDateString);
  const endDate = new Date(endDateString);

  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();
  const startMonth = startDate.getMonth();
  const endMonth = endDate.getMonth();

  if (startYear === endYear) {
    if (startMonth === endMonth) {
      // Same year and month: "1-5 april 2023"
      return `${format(startDate, "d", { locale: getLocale() })}-${format(endDate, "d MMMM yyyy", { locale: getLocale() })}`;
    } else {
      // Same year, different months: "30 april - 2 maj 2023"
      return `${format(startDate, "d MMMM", { locale: getLocale() })} - ${format(endDate, "d MMMM yyyy", { locale: getLocale() })}`;
    }
  } else {
    // Different years: "30 april 2023 - 2 maj 2024"
    return `${format(startDate, "d MMMM yyyy", { locale: getLocale() })} - ${format(endDate, "d MMMM yyyy", { locale: getLocale() })}`;
  }
};
